/**
 * Esqueleto da biblioteca com a mesma forma do conteudo final (quatro
 * cartoes de resumo, "o que fazer agora" + ranking, filtros e grade de seis
 * cartoes): a troca de escopo recarrega, e um salto de layout a cada carga e
 * desorientador.
 */

const BLOCO = 'animate-pulse rounded-2xl border border-line bg-surface';

export function EsqueletoModelos(): JSX.Element {
  return (
    <>
      <p role="status" className="sr-only">
        Carregando os modelos
      </p>
      <div aria-hidden="true" className="flex flex-col gap-6">
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className={`h-36 ${BLOCO}`} />
          ))}
        </div>
        <div className="grid gap-6 lg:grid-cols-3">
          <div className={`h-72 lg:col-span-2 ${BLOCO}`} />
          <div className={`h-72 ${BLOCO}`} />
        </div>
        <div className={`h-56 ${BLOCO}`} />
        <ul className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <li key={i} className={`h-80 ${BLOCO}`} />
          ))}
        </ul>
      </div>
    </>
  );
}
